module.exports = __webpack_public_path__ + "static/intelligent-investor-851c83eccd2d51dfe168d3a8bc06dc00.webp";